import { useEffect } from 'react';

const useFocusRef = (value = '') => {
  let inputRef = null;

  useEffect(() => {
    if (value && inputRef.selectionStart !== null) {
      inputRef.selectionStart = value.length;
    }

    inputRef.focus({ preventScroll: true });
  }, [value, inputRef]);

  // Using the ref callback to store a reference to a DOM node in an instance property
  return (element) => (inputRef = element);
};

export default useFocusRef;
